import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap, withLatestFrom, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SET_DEAL_DATE, TOGGLE_DRAWER, CLOSE_DRAWER } from './actions';
import { MarketsLoadAction } from './markets/actions';
import { CalendarLoadAction } from './calendar/actions';
import { USTreasuriesLoadAction } from './us-treasuries/actions';
import { MMDReadsLoadAction, SeeReadsAction } from './mmd/actions';
import { CalendarSeeEventAction } from './calendar/actions';
import {
  getDealDate,
  getOpenState,
  MarketDrawerRootReducerState
} from './reducer';

@Injectable()
export class MarketDrawerEffects {
  
  public readonly fetchCalendar$: Observable<
    | MarketsLoadAction
    | USTreasuriesLoadAction
    | MMDReadsLoadAction
    | CalendarLoadAction
  > = createEffect(() => this.actions.pipe(
    ofType(SET_DEAL_DATE),
    withLatestFrom(this.store.pipe(map(getDealDate))),
    mergeMap(([action, dealDate]) => {
      return [
        new MarketsLoadAction(),
        new USTreasuriesLoadAction(),
        new MMDReadsLoadAction(),
        new CalendarLoadAction(dealDate)
      ];
    })
  ));

  
  public readonly markAsRead$: Observable<
    SeeReadsAction | CalendarSeeEventAction
  > = createEffect(() => this.actions.pipe(
    ofType(TOGGLE_DRAWER, CLOSE_DRAWER),
    withLatestFrom(this.store.pipe(map(getOpenState))),
    mergeMap(([action, open]) => {
      if (!open) {
        return [new SeeReadsAction(), new CalendarSeeEventAction()];
      } else {
        return [];
      }
    })
  ));

  constructor(
    private actions: Actions,
    private store: Store<MarketDrawerRootReducerState>
  ) {}
}
